import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Optional, SkipSelf } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';

import { AuthInterceptor } from './interceptor/auth.interceptor';
import { EmailConfirmedInterceptor } from './interceptor/email-confirmed.interceptor';
import { ModuleEntitlementInterceptor } from './interceptor/module-entitlement.interceptor';

import { AuthGuard } from './guard/auth.guard';
import { NoAuthGuard } from './guard/no-auth.guard';
import { throwIfAlreadyLoaded } from './guard/module-import.guard';

import { AuthService } from '../core/service/auth/auth.service';
import { SettingsService } from '../core/service/settings/settings.service';
import { BaseComponent } from './components/base/base.component';

@NgModule({
  imports: [
    HttpClientModule
  ],
  providers: [
    SettingsService,
    AuthService,
    AuthGuard,
    NoAuthGuard,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: EmailConfirmedInterceptor,
      multi: true
    },
    // SD-1218: turns the server's 403 module_not_entitled into an app-level event, so a
    // client holding a stale entitlement set refreshes instead of silently failing.
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ModuleEntitlementInterceptor,
      multi: true
    }
  ],
  declarations: [
    BaseComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
